export enum EToasterVariant {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
